export var white = '#fff';
export var black = '#000';
export var mediumGrey = '#979797';
export var mediumLightGrey = '#cccccc';
export var lightGrey = '#e6e6e6';
export var veryVeryLightGrey = '#fafafa';

// primary light
export var lightBlue = '#34a3e7';
// primary dark
export var mediumBlue = '#4195d3';

export var blueEnabledColor = lightBlue;
export var blueHoverColor = '#5cbffb';
export var blueActiveColor = '#2085c2';

// secondary
export var greyActiveColor = '#f0f2f5';
export var greyBorderColor = '#d7dce0';
export var grayBackGroundColor = '#f8f8f8';

export var darkColor = '#2f353d';

export var controlsGrey = '#d8dce0';
export var controlsBlue = '#4195D3';
export var controlsBlueHover = '#A0CAE9';
export var controlsLightGrey = '#f1f1f1';
export var controlsDisabled = '#e5e5e5';